<template>
  <span>Eingabemodus:&nbsp;</span>
  <BulmaButton
    v-bind="$attrs"
    :icon="['fas', store.is_touch_device ? 'hand-pointer' : 'arrow-pointer']"
    :text="store.is_touch_device ? 'Touch' : 'Desktop'"
    @click.left="store.toggle_touch_device"
  />
</template>

<script setup lang="ts">
import { advent22Store } from "@/lib/store";

import BulmaButton from "./bulma/Button.vue";

const store = advent22Store();
</script>
